// @flow

import type { HTMLAST } from './types';

const isYoutubeNode = (node: HTMLAST) => {
  return (
    node.tagName === 'iframe' &&
    node.attrs &&
    node.attrs.src &&
    // Targeting only `youtube.com` videos as it is possible that other iframe
    // content is rendered on these pages. If we see this bug again with other
    // video links, we can adjust it accordingly
    node.attrs.src.includes('youtube.com')
  );
};

export default isYoutubeNode;
